import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Container,
  Text,
} from '@shared/ui';

export function ContainerShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.layout.container.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.layout.container.description')}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <Container
          size="sm"
          className="rounded-md border border-dashed border-border bg-muted/30 py-2 text-center"
        >
          <Text size="sm" color="muted">
            {t('uiLibrary.layout.container.sizes.sm')}
          </Text>
        </Container>
        <Container
          size="md"
          className="rounded-md border border-dashed border-border bg-muted/30 py-2 text-center"
        >
          <Text size="sm" color="muted">
            {t('uiLibrary.layout.container.sizes.md')}
          </Text>
        </Container>
        <Container
          size="lg"
          className="rounded-md border border-dashed border-border bg-muted/30 py-2 text-center"
        >
          <Text size="sm" color="muted">
            {t('uiLibrary.layout.container.sizes.lg')}
          </Text>
        </Container>
      </CardContent>
    </Card>
  );
}
